module.exports = __webpack_public_path__ + "media/fuzion-3.baedb887.mp4";